// Hero-Module — lazy background video + PHP Vidcon (bindPhpVidconLazyVideos)
// Actually its more about BG-Video Initialization, but we call it Hero-Module for historical reasons.

function bindPhpVidconLazyVideos(videoSelector, posterImgSelector) {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll(videoSelector).forEach((heroVideo) => {
        const videoSource = heroVideo.querySelector('source');
        if (!videoSource) return;

        const posterImg = heroVideo.parentElement?.querySelector(posterImgSelector);
        const lazySrc = videoSource.dataset.src || videoSource.getAttribute('data-src');
        const eagerSrc = videoSource.getAttribute('src');

        const hasPoster = !!(posterImg && lazySrc);

        function revealVidconIfPosterBlocksNativePlay() {
            if (!posterImg) return;
            const prev = heroVideo.previousElementSibling;
            if (prev && prev.classList.contains('vidcon')) {
                prev.classList.add('vidcon--autoplay-failed');
            }
        }

        function fadePoster() {
            if (!posterImg) return;
            posterImg.style.transition = posterImg.style.transition || 'opacity 1s ease-out';
            posterImg.style.opacity = '0';
            setTimeout(() => {
                posterImg.style.display = 'none';
            }, 1000);
        }

        function tryPlayAfterLoad() {
            if (prefersReducedMotion) {
                try {
                    heroVideo.pause();
                } catch (e) {
                    /* ignore */
                }
                return;
            }
            heroVideo
                .play()
                .then(() => {
                    if (hasPoster) {
                        fadePoster();
                    }
                })
                .catch(() => {
                    revealVidconIfPosterBlocksNativePlay();
                });
        }

        function loadFromLazy() {
            if (!lazySrc) return;
            heroVideo.src = lazySrc;
            videoSource.removeAttribute('data-src');
            heroVideo.load();
            tryPlayAfterLoad();
        }

        if (eagerSrc && !lazySrc) {
            if (!prefersReducedMotion && heroVideo.hasAttribute('autoplay')) {
                heroVideo.play().catch(() => {
                    revealVidconIfPosterBlocksNativePlay();
                });
            } else if (!prefersReducedMotion && !heroVideo.hasAttribute('autoplay')) {
                /* Manuelles Vidcon */
            } else {
                try {
                    heroVideo.pause();
                } catch (e) {
                    /* ignore */
                }
            }
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const run = () => loadFromLazy();
                if (window.requestIdleCallback) {
                    requestIdleCallback(run);
                } else {
                    setTimeout(run, 50);
                }
                observer.unobserve(heroVideo);
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0
        });

        observer.observe(heroVideo);
    });
}

/** Hero Bold (Metablock + Landing Bold): lazy data-src + Autoplay; Vidcon aus PHP */
export function initHeroboldBlockVideo() {
    bindPhpVidconLazyVideos('.section.mtkrft.herobold video.herobold-video', 'img.hero-bold-img');
}

/** Landing alternate + Hero-Alternate-Metablock */
export function initHeroaltEmbeddedVideos() {
    bindPhpVidconLazyVideos(
        '.section.mtkrft.heroalternate video.heroalt-assets-video, .section.mtkrft.landing video.heroalt-assets-video',
        'img.heroalt-assets-img'
    );
}

/** CTA-Blöcke (mehrere pro Seite → eindeutige id pro Block) */
export function initCtaBlockVideos() {
    bindPhpVidconLazyVideos('.section.mtkrft.cta video.cta-bg-video', 'img.cta-video-poster');
}

/** Numbers-Block Hintergrundvideo */
export function initNumbersBlockVideos() {
    bindPhpVidconLazyVideos('.section.mtkrft.numbers video.numbers-bg-video', 'img.numbers-video-poster');
}

/** Westbridge Klient-Hero */
export function initWestbridgeHeroVideo() {
    bindPhpVidconLazyVideos(
        '.section.mtkrft.custom-hero-westbridge video.westbridge-hero-video',
        'img.custom-hero-westbridge-img'
    );
}
